// extracted by mini-css-extract-plugin
export default {"task-page":"TaskPage_task-page__8FfEk","task-page-body":"TaskPage_task-page-body__1l7ze","center":"TaskPage_center__14b6D"};